<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 73 60" fill="none">
    <path
      d="M21.6772 39.2079C21.3158 38.846 -4.50307 12.7492 -4.50307 12.7492L-23 31.3005L4.01056 58.5038C5.37969 59.8821 7.60365 59.889 8.97973 58.5177L27.6263 39.9667C27.6263 39.9667 24.5544 42.1176 21.6702 39.2079H21.6772Z"
      fill="#3B3B3B"
    />
    <path
      d="M72.9754 -5.51855L27.6332 39.9597C27.6332 39.9597 24.5614 42.1106 21.6772 39.2009C21.3158 38.839 11.5998 29.0448 6.61676 24.019L54.5165 -24L72.9754 -5.51855Z"
      fill="url(#paint0_linear_4001_20725)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4001_20725"
        x1="13.2636"
        y1="38.2227"
        x2="34.2204"
        y2="11.4726"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1F1F1F" />
        <stop offset="0.74" stop-color="#3B3B3B" />
      </linearGradient>
    </defs>
  </svg>
</template>
